var map = {
	"./Darkred.png": 5642,
	"./Lightblue.png": 905,
	"./blue.png": 8428,
	"./green.png": 3502,
	"./orange.png": 7888,
	"./purple.png": 6714,
	"./red.png": 7285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9057;